import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img 
          src="/invexlogo.png" 
          alt="Invex Logo" 
          style={{ height: '150px', width: 'auto' }}
/>
        </Link>

        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>

        <ul className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" className={isActive('/')} onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/pricing" className={isActive('/pricing')} onClick={() => setMobileMenuOpen(false)}>
              Pricing
            </Link>
          </li>
          <li>
            <Link to="/about" className={isActive('/about')} onClick={() => setMobileMenuOpen(false)}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/contact" className={isActive('/contact')} onClick={() => setMobileMenuOpen(false)}>
              Contact
            </Link>
          </li>
          <li>
            <Link to="/support" className={isActive('/support')} onClick={() => setMobileMenuOpen(false)}>
              Support
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;